import { render, staticRenderFns } from "./AthleteScoutingReportsCard.vue?vue&type=template&id=5f156f5b&scoped=true&"
import script from "./AthleteScoutingReportsCard.vue?vue&type=script&lang=ts&"
export * from "./AthleteScoutingReportsCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f156f5b",
  null
  
)

export default component.exports